import { NotificationTitle } from "./NotificationTitle";
import { NotificationFooter } from "./NotificationFooter";
import styles from "../notification.module.css";
import { NotificationStringListBody } from "./NotificationStringListBody";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { NotificationTranslatedStringsProps } from "./types/translated-strings.types";
import { NotificationItemBaseProps } from "../../types/notification.types";

interface NotificationTranslatedStringsItemProps
  extends NotificationTranslatedStringsProps, NotificationItemBaseProps {}

export const NotificationTranslatedStringsItem = ({
  read,
  createdAt,
  onClick,
  title,
  body,
  footer,
  navigateUrl,
}: NotificationTranslatedStringsItemProps) => {
  return (
    <div
      className={styles["notification-item"] ?? ""}
      onClick={() => onClick()}
    >
      {navigateUrl ? (
        <FixaLink to={navigateUrl}>
          <NotificationTitle read={read} title={title} />
          <NotificationStringListBody body={body} />
          <NotificationFooter createdAt={createdAt} footer={footer} />
        </FixaLink>
      ) : (
        <>
          <NotificationTitle read={read} title={title} />
          <NotificationStringListBody body={body} />
          <NotificationFooter createdAt={createdAt} footer={footer} />
        </>
      )}
    </div>
  );
};
